import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { DetailList, Loading } from '@presentation/components';
import { mediaQuery } from '@presentation/styles';
import { FaHeart } from 'react-icons/fa';

export const HeaderButtons = styled.div`
  display: flex;
  gap: 18px;

  ${mediaQuery('tablet')} {
    justify-content: space-between;
  }
`;

export const infoDetailIconStyle = css`
  margin-left: 8px;
`;

export const TopWrapper = styled.div`
  margin-top: -50px;
  min-height: 300px;
  border-radius: 10px;
  background: ${(props) => props.theme.color.light.default};
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
`;

export const WarningWrapper = styled.div`
  padding: 30px;
`;

export const TopFlexWrapper = styled.div`
  display: flex;

  ${mediaQuery('medium')} {
    flex-direction: column;
  }
`;

export const TopSlideshowWrapper = styled.div`
  width: 50%;
  height: 100%;
  padding: 30px;
  ${mediaQuery('medium')} {
    padding-top: 15px;
    padding-bottom: 0;
    width: 100%;
  }
`;

export const TopDetailsWrapper = styled.div`
  padding: 20px;
  flex-grow: 1;
`;

export const TopButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: 30px;
  & > *:not(:last-child) {
    margin-bottom: 10px;
  }
`;

export const ParentContainer = styled.div`
  margin-bottom: 50px;
  display: flex;

  & > *:not(:last-child) {
    margin-right: 30px;
  }

  ${mediaQuery('tablet')} {
    margin-bottom: 0;
    & > *:not(:last-child) {
      margin-bottom: 30px;
    }
    flex-direction: column;
  }
`;

export const ParentCard = styled.div`
  width: 50%;
  display: flex;
  align-items: center;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
  ${mediaQuery('medium')} {
    width: 100%;
    flex-direction: column;
  }
`;

export const ParentImage = styled.img`
  margin-right: 30px;
  border-radius: 100%;
  width: 150px;
  height: 150px;
  object-fit: cover;
  cursor: pointer;
  -webkit-touch-callout: none;
  -webkit-user-select: none;

  ${mediaQuery('tablet')} {
    margin-right: 0;
    margin-bottom: 15px;
    width: 100px;
    height: 100px;
  }
`;

export const ParentTitle = styled.h3`
  font-family: ${(props) => props.theme.font.alternate};
  font-weight: 600;
  color: ${(props) => props.theme.color.blue.default};
  font-size: 22px;
  margin-bottom: 5px;
`;

export const ParentSubtitle = styled.p`
  font-weight: 600;
  font-size: 18px;
  line-height: 1.4;
  margin: 0;
  margin-bottom: 10px;
`;

export const ParentLabel = styled.div`
  font-size: 16px;
  font-weight: 400;
  white-space: break-spaces;

  strong {
    font-weight: 700;
  }
`;

export const DescriptionContainer = styled.div`
  display: flex;
  & > *:not(:last-child) {
    margin-right: 100px;
  }

  ${mediaQuery('medium')} {
    & > *:not(:last-child) {
      margin-right: 30px;
    }
  }
  ${mediaQuery('tablet')} {
    flex-direction: column;
    margin-right: 0;
    & > *:not(:last-child) {
      margin-bottom: 30px;
    }
  }
`;

export const BreedCardWrapper = styled.div`
  min-width: 300px;
  max-width: 300px;
  ${mediaQuery('tablet')} {
    max-width: 100%;
    width: 100%;
  }
`;

export const AwarenessBannerWrapper = styled.div`
  margin-top: 50px;
`;

export const WishlistWrapper = styled.div<{ loading?: boolean }>`
  display: flex;
  align-items: center;
  font-weight: 700;
  cursor: ${(props) => (props.loading ? 'wait' : 'pointer')};
  & > *:not(:last-child) {
    margin-right: 5px;
  }
`;

export const WishlistHeart = styled(FaHeart)<{ wishlisted?: boolean }>`
  color: ${(props) => (props.wishlisted ? props.theme.color.medium.tint : 'inherit')};
`;

export const WishlistLoading = styled(Loading)`
  width: 15px;
  height: 15px;
`;

// Contact card

export const ContactContainer = styled.div`
  margin-bottom: 50px;
  display: flex;
  & > *:not(:last-child) {
    margin-right: 30px;
  }
  align-items: center;
  padding: 30px;
  border-radius: 10px;
  background: ${(props) => props.theme.color.light.default};
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);

  #card-contact {
    padding: 0;
    background: none;
    box-shadow: none;
    flex-grow: 1;
  }

  ${mediaQuery('medium')} {
    flex-direction: column;
    align-items: stretch;
    & > *:not(:last-child) {
      margin-right: 0;
      margin-bottom: 30px;
    }
  }
`;

export const ContactImgWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const ContactLink = styled.a`
  white-space: nowrap;
`;

export const ContactImg = styled.img`
  margin-bottom: 15px;
  border-radius: 100%;
  width: 150px;
  height: 150px;
  object-fit: cover;
  -webkit-touch-callout: none;
  -webkit-user-select: none;

  ${mediaQuery('medium')} {
    margin: inherit auto;
  }

  ${mediaQuery('tablet')} {
    width: 100px;
    height: 100px;
  }
`;

export const ContactDetailList = styled(DetailList)`
  width: 100%;
  & > div {
    width: 45%;
    margin: 0 2.5%;
    display: inline-flex;

    ${mediaQuery('tablet')} {
      width: 100%;
    }
  }
`;

export const VerticalMargin = styled.div`
  margin-top: 50px;
  margin-bottom: 50px;
`;

export const StoreBannerContainer = styled.div`
  margin-top: 25px;
  margin-bottom: 25px;
  margin-left: auto;
  margin-right: auto;
`;

export const TranslatableDescription = styled.div`
  display: flex;
  flex-direction: column;
`;
